import React, { Component } from 'react'
import { Switch, Route, BrowserRouter as Router, Redirect } from 'react-router-dom'
import { env } from 'components/Helpers'
import { Logo } from './components'

// admin-auth-consolidation Phase 2: login, reset and set-password are no longer
// native React against admin-api's legacy /v0. They are the <cl-login> /
// <cl-reset-password> / <cl-update-password> web components served by
// `administrators` (the service that owns admin identity), mounted the same way
// <cl-admins> already is.
//
// This drops the client's dependency on the F313 enumeration oracle
// (/v0/login/admins?username=) and the pre-auth /v0/operators list: <cl-login>
// sends only email + password, and `administrators` resolves the operator
// server-side AFTER the password verifies. The multi-operator picker lives
// inside the web component.
//
// S3.6: <cl-update-password> replaces the React UpdatePassword on
// /password/update. It reads `operator` + `token` from the reset-link query
// string itself and sends plaintext to `administrators` /v1/auth/update (the
// plaintext contract from Phase 1a PR2). On success it renders its own
// confirmation with a "Log in" link — the host does not redirect.
export default class Login extends Component {
  constructor (props) {
    super(props)

    this.containerRef = React.createRef()
    this._handleAuthSuccess = this._handleAuthSuccess.bind(this)
  }

  // <cl-login> hands the token UP rather than writing storage itself, so the
  // host owns where it lands. `cl-auth-success` is bubbling + composed, so a
  // single listener on the container catches it through the shadow boundary.
  componentDidMount () {
    const container = this.containerRef.current
    if (container) {
      container.addEventListener('cl-auth-success', this._handleAuthSuccess)
    }
  }

  componentWillUnmount () {
    const container = this.containerRef.current
    if (container) {
      container.removeEventListener('cl-auth-success', this._handleAuthSuccess)
    }
  }

  render () {
    const apiHost = `https://administrators.${env()}.credlock.net`

    return (
      <div className='login' ref={this.containerRef}>
        <Logo />
        <Router>
          <Switch>
            <Route exact path='/'>
              <cl-login apiHost={apiHost} />
            </Route>
            <Route path='/password/reset'>
              <cl-reset-password apiHost={apiHost} locale='en' />
            </Route>
            <Route path='/password/update'>
              <cl-update-password apiHost={apiHost} />
            </Route>
            <Redirect from='/' to='/' />
          </Switch>
        </Router>
      </div>
    )
  }

  _handleAuthSuccess (event) {
    // <cl-update-password> is mounted inside this same container and dispatches a
    // detail-less `cl-password-updated` on success (it has no token to hand up).
    // Guard against any detail-less event reaching this listener so we never
    // write `undefined` into the host session before storing.
    const { token, user } = event.detail || {}
    if (!token || !user) return

    // NOTE: the token handoff stays in localStorage for this cutover — a locked
    // decision. It knowingly keeps F004/F096 in place; moving the admin token to
    // an HttpOnly cookie is owned by the ui-token-storage-and-csp workstream.
    // TODO: Use a storage component?
    window.localStorage.setItem('auth-token', token)
    window.localStorage.setItem('currentAdmin', JSON.stringify(user))
    this.props.login(token, JSON.stringify(user))
  }
}
